'use strict';

angular.module('shiftTraderApp')
    .directive('saChangeTargetHours', function ($compile, $timeout, UserPermissionsService, toastr) {
      var tooltipTemplate = '<div class="sa_change_target_hours_tooltip">' +
        '<div class="adjustment_row">' +
          '<button class="sa_button sa_small sa_gray" data-ng-click="decHours()">-</button>' +
          '<input class="sa_input sa_small target_hours_input" data-ng-model="formData.target_hours" type="number">' +
          '<button class="sa_button sa_small sa_gray" data-ng-click="incHours()">+</button>' +
        '</div>' +
        '<div class="submit_row text-center">' +
          '<button class="sa_button sa_tiny sa_blue" data-ng-disabled="formData.target_hours === availabilitySet.target_hours" data-ng-click="saveTargetHours()">Save</button>' +
          '<button class="sa_button sa_tiny sa_gray" data-ng-click="close()" style="margin-left: 8px;">Close</button>' +
        '</div>' +
        '</div>';
      return {
        template: '<div ng-transclude></div>' +
                  '<div class="change_container" data-ng-click="toggleTooltip()">Change</div>',
        restrict: 'A',
        transclude: true,
        scope: {
          availabilitySet: '=availabilitySet',
          emp: '='
        },
        link: function link (scope, elem) {
          var canChangeTarget = null;

          var openDelay = 300;

          var tooltipTemplateLinker = $compile(tooltipTemplate);

          var tooltipOpenState = false;
          var tooltip;
          var tappedOpen;
          var tooltipTimeout;

          var positionTooltip = function () {
            var dayAreaHeight = $(elem).outerHeight();
            var dayAreaWidth = $(elem).outerWidth();
            var tooltipWidth = tooltip.outerWidth();

            tooltip.css({
              top: 17,
              left:  (-1 * tooltipWidth + dayAreaWidth)/ 2.0
            });
          };

          var hoverIn = function () {
            $(elem).addClass('hovering');
            if (!tooltipOpenState) {
              toggleTooltipOpen();
            }
          };

          var hoverOut = function () {
            $(elem).removeClass('hovering');

            if (!tappedOpen) {
              closeTooltip(true);
            }
          };

          var openTooltip = function () {
            if (!tooltipTimeout) {
              tooltipTimeout = $timeout(function() {
                tooltip = tooltipTemplateLinker(scope, function () {});
                tooltip.css({top: 17, left: 0, display: 'block', 'z-index': 14000});
                elem.append( tooltip );
                positionTooltip();
                scope.$digest();
                tooltipOpenState = true;
                $timeout(function() {
                  tooltip.addClass('active');
                }, 0);

              }, openDelay);
            }
          };

          var closeTooltip = function (animate) {
            tooltipOpenState = false;
            $timeout.cancel(tooltipTimeout);
            tooltipTimeout = undefined;
            if (tooltip) {
              if (animate) {
                tooltip.removeClass('active');
                $timeout(function() {
                  if (tooltip) {
                    tooltip.remove();
                  }
                  tooltip = null;
                }, 300);
              } else {
                tooltip.remove();
                tooltip = null;
              }
            }

          };

          var toggleTooltipOpen = function () {
            if (!tooltipOpenState) {
              openTooltip();
            } else {
              closeTooltip(true);
            }
          };

          // Make sure tooltip is destroyed and removed.
          scope.$on('$destroy', function onDestroyTooltip() {
            closeTooltip(false);
            tappedOpen = false;
          });

          scope.$watch('availabilitySet.id', function(newVal, oldVal) {
            if (newVal) {

              UserPermissionsService.can('availability_sets.change_target_hours', scope.availabilitySet.organization_id)
                .then(function(result) {
                  canChangeTarget = result;

                  if (canChangeTarget) {
                    $(elem).find('.change_container').addClass('has_permissions');
                  }
                });

              scope.formData = {
                target_hours: scope.availabilitySet.target_hours
              };

              $(elem).find('.change_container').addClass('active');
            } else {
              $(elem).find('.change_container').removeClass('active');
            }
            //console.log('availabilitySet in saChangeTargetHours', scope.availabilitySet);
          });


          scope.toggleTooltip = function() {
            toggleTooltipOpen();
          };

          scope.incHours = function() {
            scope.formData.target_hours += 1;
          };

          scope.decHours = function() {
            scope.formData.target_hours -= 1;
          };

          scope.saveTargetHours = function() {
            scope.availabilitySet.$update({
              state: 2,
              target_hours: scope.formData.target_hours
            })
              .then(function(resp) {
                scope.availabilitySet.target_hours = resp.target_hours;
                var availSet = _.find(scope.emp.availability_sets, {id: scope.availabilitySet});

                if (availSet) {
                  availSet.target_hours = resp.target_hours;
                }

                toastr.success('Target hours updated.', 'Success');
                toggleTooltipOpen();
                scope.$emit('smartScheduling:lineitem:recalculate', {user_id: scope.emp.id});
              }, function() {
                scope.formData.target_hours = scope.availabilitySet.target_hours;
                toastr.error('Target hours update failed. Please try again.', 'Error');
              });
          };
          scope.close = function() {
            toggleTooltipOpen();
          };
        }
      };
    });
